"use client";

import { VidMuseEvent } from "@/common/events";
import { logger } from "@/common/logger";
import { MobileWarningModal } from "@/component/MobileWarningModal";
import { OnboardingModal } from "@/component/OnboardingModal";
import { useDeviceDetection } from "@/hooks/useDeviceDetection";
import { setupChunkErrorHandler } from "@/util/chunkErrorHandler";
import { safeLocalStorageSetItem } from "@/util/safeLocalStorage";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

const ONBOARDING_COMPLETED_KEY = "vidmuse_onboarding_completed";

export function Init() {
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [showOnboardingModal, setShowOnboardingModal] = useState(false);
  const { isMobile } = useDeviceDetection();

  useEffect(() => {
    logger.init();
    // Setup chunk error handler to handle loading failures
    setupChunkErrorHandler();
  }, []);

  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pathname) return;

    // Map pathname to page exposure event
    let event: VidMuseEvent | null = null;
    if (pathname === "/") {
      event = VidMuseEvent.HomePageDisplayed;
    } else if (pathname.startsWith("/login")) {
      event = VidMuseEvent.LoginPageDisplayed;
    } else if (pathname === "/thread") {
      event = VidMuseEvent.ThreadListPageDisplayed;
    } else if (pathname.startsWith("/share/")) {
      event = VidMuseEvent.ThreadSharePageDisplayed;
    } else if (pathname.startsWith("/thread/")) {
      event = VidMuseEvent.ThreadDetailPageDisplayed;
    } else if (pathname === "/pricing") {
      event = VidMuseEvent.PricingPageDisplayed;
    }

    if (event) {
      logger.event(event);
    }
  }, [pathname]);

  useEffect(() => {
    // Check for paySuccess parameter in URL on home page
    if (pathname === "/") {
      const paySuccess = searchParams?.get("paySuccess");
      const payValue = searchParams?.get("payValue");
      const isNewUser = searchParams?.get("newUser");
      const loginSuccess = searchParams?.get("loginSuccess");
      if (paySuccess === "true") {
        logger.event(VidMuseEvent.Purchase, {
          currency: "USD",
          value: payValue,
        });
      }

      if (isNewUser === "true" && loginSuccess === "true") {
        const loginFrom = searchParams?.get("loginFrom");
        logger.event(VidMuseEvent.NewUserJoin, {
          value: {
            loginFrom,
          },
        });

        // Show onboarding modal if not completed before
        // const hasCompletedOnboarding =
        //   safeLocalStorageGetItem(ONBOARDING_COMPLETED_KEY) === "true";
        // if (!hasCompletedOnboarding) {
        //   setShowOnboardingModal(true);
        // }
      }
    }
  }, [pathname, searchParams]);

  useEffect(() => {
    if (isMobile) {
      setShowMobileModal(true);
    }
  }, [isMobile]);

  const handleClose = () => {
    setShowMobileModal(false);
  };

  const handleOnboardingComplete = () => {
    // Mark as completed in localStorage
    safeLocalStorageSetItem(ONBOARDING_COMPLETED_KEY, "true");

    // Close modal (always close, even if storage fails)
    setShowOnboardingModal(false);
  };

  if (pathname?.startsWith("/thread/")) {
    return <MobileWarningModal open={showMobileModal} onClose={handleClose} />;
  }

  return (
    <>
      <OnboardingModal
        open={showOnboardingModal}
        onComplete={handleOnboardingComplete}
      />
    </>
  );
}
